/**
 * contiene la información para el manejo de productos de generales.
 */
export const defaultProducto = () => {
    return {
        Idproducto: '',
        activo: 1,
        verificado: 0,
        nombre: '',
        sinonimos: '',
        componentesactivos: '',
        componentesactivosIngles: '',
        cas: '',
        estado: '',
        id_fabricante: null,
        uso: '',
        observacion: '',
        disposiciontratamiento: '',
        doc_sga: '',
        doc_etiqueta: '',
        fecha_etiqueta: '',
    }
}

export const defaultRpqMasivoProductos = () => {
    return {
        'verificado': [],
        'asignado': [],
        'pago': [],
        'te': []
    }
}

/**
 * Filtros de búsqueda por default
 *
 * @return {*}
 */
export const defaultFiltro = () => {
    return {
        empresa: "",
        nombre: "",
        sinonimos: "",
        id_fabricante: null,
        confecha: ['',''],
        ubicaciones: [],
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sinVerificar: false,
        sinAsignar: false,
        sinPagar: false,
        sinTE: false,
        sort: 'DESC',
        bloqueado: false,
        estado: null,
        selectorMultiple: false,
        te_gen: false,
        te_adj: false,
        tipo: '',
        in_use: null
    }
}

/**
 * Carga todas las variables declaradas en el proceso.
 */
export default {
    // selectedProduct: defaultProducto(),
    selectedProduct: {
        Idproducto: '',
        activo: 1,
        verificado: 0,
        nombre: '',
        sinonimos: '',
        componentesactivos: [],
        componentesactivosIngles: '',
        cas: '',
        estado: '',
        id_fabricante: null,
        uso: '',
        observacion: '',
        disposiciontratamiento: '',
        doc_sga: '',
        doc_etiqueta: '',
        fecha_etiqueta: '',
    },
    empresas: [],
    productos: [],
    bases: [],
    areas: [],
    campos: [],
    fabricantes: [],
    control_existe: [],
    accion: 'create',
    error: '',
    esAdmin: false,
    esEmpresa: false,
    filtro: defaultFiltro(),
    info:{
        empresa:"",
        producto:""
    },
    rpqMasivoProductos: defaultRpqMasivoProductos(),
    ubicaciones:[],
    ubicacionesContratista:[],
    seleccionado:[],
    marcados:[],
    ubicacion:[],
    camposPersonalizados:[],
    list_basesareas:[],
    tlvs:[],
    iarcs:[],
    otos:[],
    neuros:[],
    scs:[],
    bios:[],
    repros:[],
    mutas:[],
    teras:[],
    codigoqr:{
        qr: '',
        qr2: '',
        mensajeqr: ''
    },
  cargando_datos_select: false,
  estados: [
      {
        id: 1,
        text: 'Aprobados',
        color: '#cdedd8'
      },
      {
        id: 2,
        text: 'Pendientes',
        color: '#feeeba'
      },
      {
        id: 3,
        text: 'Incompletos',
        color: '#fcd6d6'
      }
  ]
}
